export default __webpack_public_path__ + "f3aabbc075e2c81a0b264fa8bdc3a8ea.svg";